module.exports = __webpack_public_path__ + "img/3.050c9ad3.jpeg";